//
// << Autogenerated, do not edit. All changes will be undone. >>
//
// The Program is owned by IBM or an IBM supplier, and is copyrighted and licensed, not sold.
//
// @author ISC Carlos Ernesto Islas Garcia <cernesto@mx1.ibm.com>
// @version 23 Jan 2017
// @licensed
//
(function initModule(define) {
  define([ 'app/app', 'libs/q/q', 'jquery', 'underscore', ], function defineModule(Application, Q, $, _) {
    var Messages = {
      url: {
        missing: 'Request URL is missing',
      },
      body: {
        missing: 'Request body is missing',
      },
    };

    function ajaxSend(url, method, data) {
      return $.ajax({
        url: url,
        method: method,
        accepts: {
          json: 'application/json; charset=utf-8',
        },
        // Send as JSON.
        contentType: 'application/json; charset=utf-8',
        // Expected format from response.
        dataType: 'json',
        data: data,
        success: function success() {
          // does nothing... yet!
        },
        error: function error() {
          // does nothing... yet!
        },
      });
    }

    function getMessage(jqxhr) {
      var messageFromJson;
      if (jqxhr && jqxhr.responseJSON && jqxhr.responseJSON.errors) {
        messageFromJson = jqxhr.responseJSON.errors[0].detail;
      }
      return messageFromJson;
    }

    function doCallback(promise, callback) {
      promise.done(function done(data, status) {
        callback(undefined, {
          data: data,
          status: status,
        });
      }).fail(function fail(jqxhr, status, error) {
        callback({
          error: error,
          status: status,
          message: getMessage(jqxhr),
        }, undefined);
      });
    }

    function doPromise(promise) {
      var deferred = Q.defer();
      promise.done(function done(data, status) {
        deferred.resolve({
          data: data,
          status: status,
        });
      }).fail(function fail(jqxhr, status, error) {
        deferred.reject({
          error: error,
          status: status,
          message: getMessage(jqxhr),
        });
      });

      return deferred.promise;
    }

    function send(url, method, data, callback) {
      var promise = ajaxSend(url, method, data);
      if (_.isFunction(callback)) {
        return doCallback(promise, callback);
      }
      return doPromise(promise);
    }

    function bridgeGet(url, parameters, callback) {
      var params = parameters;
      var cb = callback;

      // URL must be provided.
      if (!url || !_.isString(url)) {
        throw new Error(Messages.url.missing);
      }

      // When parameters are not provided, but callback is.
      if (_.isFunction(params)) {
        cb = params;
        params = {};
      } else if (!_.isObject(params)) {
        params = {};
      }

      return send(url, 'GET', $.param(params), cb);
    }

    function bridgePost(url, body, callback) {
      // URL must be provided.
      if (!url || !_.isString(url)) {
        throw new Error(Messages.url.missing);
      }

      // Request body must be provided.
      if (!body || !_.isObject(body)) {
        throw new Error(Messages.body.missing);
      }

      return send(url, 'POST', JSON.stringify(body), callback);
    }

    function bridgePut(url, body, callback) {
      // URL must be provided.
      if (!url || !_.isString(url)) {
        throw new Error(Messages.url.missing);
      }

      // Request body must be provided.
      if (!body || !_.isObject(body)) {
        throw new Error(Messages.body.missing);
      }

      return send(url, 'PUT', JSON.stringify(body), callback);
    }

    Application.module('RestClient', function createModule(Module) {
      Module.get = function get(url, params, callback) {
        return bridgeGet(url, params, callback);
      };

      Module.post = function post(url, body, callback) {
        return bridgePost(url, body, callback);
      };

      Module.put = function post(url, body, callback) {
        return bridgePut(url, body, callback);
      };
    });

    Application.reqres.setHandler('rest:get', function handler(url, params, callback) {
      return bridgeGet(url, params, callback);
    });

    Application.reqres.setHandler('rest:post', function handler(url, body, callback) {
      return bridgePost(url, body, callback);
    });

    Application.reqres.setHandler('rest:put', function handler(url, body, callback) {
      return bridgePut(url, body, callback);
    });

    return Application.RestClient;
  });
}(define));
